import StudentFacingData from "../../../../interfaces/StudentFacingData";
import accuracyToBand from "../../../../utils/AccuracyToBand";
import { Typography } from "@material-ui/core";
import Shiitake from "shiitake";

interface ScreenProps {
  studentFacingData?: StudentFacingData;
  accuracy?: number;
  wordsPerMin?: number;
}

export default function StudentsStatsWidget(props: ScreenProps) {
  // See if we can render anything
  if (!props.studentFacingData?.accuracy && !props.studentFacingData?.wordsPerMinute) {
    return <div />;
  }

  // See if we're still calculating anything
  let calculating = false;

  if (props.studentFacingData?.accuracy && props.accuracy === undefined) {
    calculating = true;
  }

  if (props.studentFacingData?.wordsPerMinute && (props.wordsPerMin === undefined || isNaN(props.wordsPerMin))) {
    calculating = true;
  }

  let finalString = "";

  if (calculating) {
    finalString = "Calculating...";
  } else {
    const accuracyString = props.studentFacingData?.accuracy ? accuracyToBand(props.accuracy ?? 0) : undefined;
    const wpmString = props.studentFacingData?.wordsPerMinute ? props.wordsPerMin + " WPM" : undefined;

    if (accuracyString && wpmString) {
      finalString = accuracyString + " | " + wpmString;
    } else if (accuracyString) {
      finalString = accuracyString;
    } else if (wpmString) {
      finalString = wpmString;
    }
  }

  // If we can show them both, render both
  return (
    <Typography component="div" className="words">
      {" "}
      <Shiitake lines={2}>{finalString}</Shiitake>
    </Typography>
  );
}
